//
import { mapActions, mapState } from 'vuex'
import { CrudCreateButton } from '@/components/reusable_components'
import { ModelDataTable } from '@/components/reusable_components/next'

//
import OrdererModel from '@/models/Warehouse/WhOrdererToList'
import filters from './filters'
import headers from './headers'

//
export default {
    name: 'dispatch-requests-list',
    components: {
        'crud-create-button': CrudCreateButton,
        'crud-data-table': ModelDataTable,
    },
    computed: {
        /**
         *
         */
        tableProps() {
            return {
                service: OrdererModel,
                filters,
                headers,
            }
        },

        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    data() {
        return {
            selected: null,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
            setAppToolbarItems: 'setAppToolbarItems',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        refresh() {
            this.$refs.table.refresh()
        },

        /**
         *
         */
        deleteSelected() {
            this.selected
                .delete()
                .catch(this.showResponse)
                .then(this.resetSnackbar)
                .then(this.showResponse)
        },

        /**
         *
         */
        resetSnackbar(event) {
            this.resetSnackbarState()
            return event
        },

        /**
         *
         */
        showResponse(response) {
            switch (response.status) {
                case 200:
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Solicitud de despacho eliminado.',
                        this.refresh
                    )
                    break
                default:
                    this.showSnackbar(
                        'error',
                        'Error.',
                        response.message,
                        this.refresh
                    )
                    break
            }
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback = () => {}) {
            this.initSnackbar(this.fillSnack(type, title, message))
            callback()
        },

        /**
         *
         */
        submitCreate() {
            this.$router.push({ name: 'orderer-create' })
        },

        /**
         *
         */
        submitDelete(event) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('eliminar item')
            this.showSnackbar(
                'warning',
                '¿Deseas eliminar la solicitud de despacho?',
                'Una vez eliminada no se puede recuperar.'
            )

            //
            this.selected = event.item
        },

        /**
         *
         */
        submitUpdate(event) {
            this.$router.push({
                name: 'orderer-update',
                params: { id: event.item.id },
            })
        },
    },
    beforeMount() {
        this.setTitleTopBar('Solicitudes de abastecimiento')
        this.setAppToolbarItems({
            items: [
                {
                    action: this.submitCreate,
                    color: 'accent',
                    icon: 'add_circle',
                    text: 'crear solicitud de abastecimiento',
                    tip: 'Crear nueva solicitud de abastecimiento',
                    can: 'CREATE_WAREHOUSE_ORDERER',
                },
            ],
        })
    },
    watch: {
        /**
         *
         */
        async responseConfirm(value) {
            switch (value) {
                case 'eliminar item':
                    this.deleteSelected()
                    break
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_WAREHOUSE_ORDERER')) ctx.$router.push('/')
        })
    },
}
